import { Search } from '@carbon/icons-react';
import { VertBox } from 'component/basics';
import { colorTextSecondary } from 'component/color';
import {
    CardHeading,
    CharacterCounter,
    DataVizText,
    DEPRECATED_EditorialHeading,
    Heading,
    Paragraph,
    TextArea,
    TextField,
    UtilityText,
} from 'component/text';
import { useState } from 'react';
import { component, componentWithVariants, demoFile, variant } from 'system/demo';

demoFile('component/text', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=1102-3167&t=MC9nppcf9h2iJDKP-1',
});

function UITextDemo() {
    return (
        <VertBox gap={4}>
            <Heading text='Heading 2xl medium' type='2xl' weight='medium' />
            <Heading text='Heading large medium' type='large' weight='medium' />
            <Heading text='Heading small strong' />
            <Paragraph text='Paragraph large' type='large' />
            <Paragraph strong text='Paragraph small strong' type='small' />
            <Paragraph text='Paragraph small' type='small' />
            <UtilityText text='Utility large medium' type='large' weight='medium' />
            <UtilityText text='Utility large' type='large' />
            <UtilityText text='Utility small medium' type='small' weight='medium' />
            <UtilityText text='Utility small' type='small' />
            <UtilityText color={colorTextSecondary} text='Utility small color:TextGrey' type='small' />
            <UtilityText text='Utility small Underline' type='small' underline />
            <UtilityText caps text='Utility tiny Caps medium' type='tiny' weight='medium' />
            <UtilityText caps text='Utility tiny Caps' type='tiny' />
            <UtilityText text='Utility tiny strong' type='tiny' weight='strong' />
            <UtilityText text='Utility tiny medium' type='tiny' weight='medium' />
            <UtilityText text='Utility tiny' type='tiny' />
            <CardHeading text='Card heading large' type='large' />
            <CardHeading text='Card heading small' type='small' />
        </VertBox>
    );
}

componentWithVariants('UI Text', UITextDemo, {}, [variant(null)]);

function BrandTextDemo() {
    return (
        <VertBox gap={4}>
            <DEPRECATED_EditorialHeading text='Editorial Heading Large' />
            <DEPRECATED_EditorialHeading italic text='Editorial Heading Large Italic' />
            <DEPRECATED_EditorialHeading text='Editorial Heading Small' type='small' />
            <DEPRECATED_EditorialHeading italic text='Editorial Heading Small Italic' type='small' />
        </VertBox>
    );
}

componentWithVariants('Brand Text', BrandTextDemo, {}, [variant(null)]);

function DataVizTextDemo() {
    return (
        <VertBox gap={4}>
            <DataVizText text='Data viz heading large strong' type='large' />
            <DataVizText text='Data viz heading small' type='small' />
        </VertBox>
    );
}

component('DataViz Text', DataVizTextDemo);

function TextFieldDemo() {
    const [text, setText] = useState<string | null>(null);

    return (
        <VertBox gap={16} wide>
            <TextField multiline={true} onChange={setText} placeholderText='Multiline text input' value={text} />
            <TextField multiline={false} onChange={setText} placeholderText='Single line text input' value={text} />
            <TextField icon={Search} multiline={false} onChange={setText} placeholderText='Single line with icon' value={text} />
        </VertBox>
    );
}

component('TextField', TextFieldDemo);

function TextAreaDemo() {
    const [text, setText] = useState<string | null>(null);
    return (
        <VertBox gap={16} wide>
            <TextArea onChange={setText} placeholderText='Multiline text input. Automatically `multiline` and `big`.' value={text} />
        </VertBox>
    );
}

component('TextArea', TextAreaDemo);

function CharacterCounterDemo() {
    return (
        <VertBox gap={4}>
            <CharacterCounter max={10} text='Me too' />
            <CharacterCounter max={10} text='' />
            <CharacterCounter max={10} text='0123456789001234567890' />
            <CharacterCounter max={100} min={10} text='Me too' />
            <CharacterCounter
                max={80}
                min={10}
                text='0123456789012345678901234567890012345678901234567890123456789001234567890123456789012345678900123456789012345678901234567890'
            />
            <CharacterCounter max={20} min={10} text='012345678901234567' />
        </VertBox>
    );
}

component('Character Counter', CharacterCounterDemo);
